
import ReturnOrderComponent from '../../components/admin/returnOrders/ReturnOrderComponent'
import ReturnOrderCreateAndEditComponent from '../../components/admin/returnOrders/ReturnOrderCreateAndEditComponent'
import ReturnOrderListComponent from '../../components/admin/returnOrders/ReturnOrderListComponent'
import ReturnOrderShowComponent from '../../components/admin/returnOrders/ReturnOrderShowComponent'

export default [
    {
        path:'/admin/solicitudes-devolucion',
        component: ReturnOrderComponent,
        name: 'admin.return-order',
        redirect: {name: 'admin.return-order'},
        meta: {
            isFrontend:false,
            auth:true,
            permissionUrl: 'return-orders',
            breadcrumb:'return_orders'
        },
        children: [
            {
                path:'',
                component: ReturnOrderListComponent,
                name: 'admin.return-order.list',
                meta: {
                    isFrontend:false,
                    auth:true,
                    permissionUrl: 'return-orders',
                    breadcrumb: ''
                }

            },
            {
                path: 'crear',
                component: ReturnOrderCreateAndEditComponent,
                name: 'admin.return-order.create',
                meta: {
                    isFrontend:false,
                    auth:true,
                    permissionUrl: 'return_order_create',
                    breadcrumb: 'create'
                }
            },
            {
                path: 'ver/:id',
                component: ReturnOrderShowComponent,
                name: 'admin.return-order.show',
                meta: {
                    isFrontend:false,
                    auth:true,
                    permissionUrl: 'return_order_show',
                    breadcrumb: 'view'
                }
            },
            {
                path: 'editar/:id',
                component: ReturnOrderCreateAndEditComponent,
                name: 'admin.return-order.edit',
                meta: {
                    isFrontend:false,
                    auth:true,
                    permissionUrl: 'return_order_edit',
                    breadcrumb: 'edit'
                }
            }
        ]
    }
]